import { render, staticRenderFns } from "./MoveProject.vue?vue&type=template&id=7c7d85c0&scoped=true&"
import script from "./MoveProject.vue?vue&type=script&lang=js&"
export * from "./MoveProject.vue?vue&type=script&lang=js&"
import style0 from "./MoveProject.vue?vue&type=style&index=0&id=7c7d85c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7d85c0",
  null
  
)

export default component.exports